import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{avatar this.item imageSize=\"tiny\"}}\n\n<span class=\"username\">{{format-username this.item.username}}</span>\n\n{{#if this.item.name}}\n  <span class=\"name\">{{this.item.name}}</span>\n{{/if}}", {
  moduleName: "select-kit/components/user-chooser/user-row.hbs"
});